<script setup lang="ts">
import { onMounted } from 'vue'
import { useToastrStore } from './toastr'
import { registerToastService } from './toastrService'

const { toasts, remove, show } = useToastrStore()

function toastClasses(type: string) {
    return {
        'bg-green-600': type === 'success',
        'bg-red-600': type === 'error',
        'bg-blue-600': type === 'info',
        'bg-yellow-500': type === 'warning',
    }
}

onMounted(() => { registerToastService({ show }) })
</script>
<template>
    <div class="fixed top-4 right-4 z-5001 flex flex-col gap-3 w-96">
        <TransitionGroup name="fade" tag="div">
            <div v-for="toast in toasts" :key="toast.id" @click="remove(toast.id)"
                class="rounded-xl shadow-md p-4 text-white flex justify-between items-start mb-1 cursor-pointer"
                :class="toastClasses(toast.type)">
                <div class="flex-1 pr-2">
                    <div v-html="toast.message"></div>
                </div>
                <button @click="remove(toast.id)" class="text-white"><i class="fa-solid fa-xmark"></i></button>
            </div>
        </TransitionGroup>
    </div>
</template>

<style scoped>
.fade-enter-active,
.fade-leave-active {
    transition: all 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
    transform: translateY(-10px);
}
</style>
